module.exports = __webpack_public_path__ + "static/media/clases.f8cdabd1.png";